export class Settings {
    public constructor(settings: any) {
        Object.assign(this, settings);
    }
}
export interface Settings {
    base: string;
    url(url: string): string;
    name: string;
    author: string;
    program: string;
    description: string;
    minDate: string;
    mainMenu: Array<{ icon: [string, string]; title: string; to: string; exact: boolean }>;
    errorPages: {
        default: { icon: [string, string]; title: string; message: string; statusCode: number };
        [code: string]: { icon: [string, string]; title: string; message: string; statusCode: number };
    };
    card: string;
    headerLogo: string;
    headerLogoAltuviiioPatient: string;
    headerLogoAltuviiioHCP: string;
    headerLogoCablivi: string;
    genzymeLogo: string;
    LogoCablivi: string;
    LogoAlprolix: string;
    LogoAltuviiio: string;
    LogoAltuviiioHcp: string;
    NoImage: string;
    LogoSarclisaHcp: string;
    headerLogoAlprolix: string;
    footerLogo: string;
    footerDrugLogo: string;
    footerPharmaLogo: string;
    cardTypeQuestionId: string;
    cardTypeAnswerId: string;
    programId: string;
    surveyId: string;
    enrollmentTypeQuestion: string;
    enrollmentTypePatient: string;
    enrollmentTypeHCP: string;
    isFederalQuestionIdPatient: string;
    isFederalAnswerYesIdPatient: string;
    isFederalAnswerNoIdPatient: string;
    isFederalQuestionIdHCP: string;
    isFederalAnswerYesIdHCP: string;
    isFederalAnswerNoIdHCP: string;
    isCommerciallyInsuredQuestionIdPatient: string;
    isCommerciallyInsuredAnswerYesIdPatient: string;
    isCommerciallyInsuredAnswerNoIdPatient: string;
    isCommerciallyInsuredQuestionIdHcp: string;
    isCommerciallyInsuredAnswerYesIdHcp: string;
    isCommerciallyInsuredAnswerNoIdHcp: string;
    isUSResidentQuestionIdPatient: string;
    isUSResidentAnswerYesIdPatient: string;
    isUSResidentAnswerNoIdPatient: string;
    isAbove18YearsOfAgeQuestionIdPatient: string;
    isAbove18YearsOfAgeAnswerYesIdPatient: string;
    isAbove18YearsOfAgeAnswerNoIdPatient: string;
    marketingOptInQuestionIdPatient: string;
    marketingOptInAnswerYesIdPatient: string;
    marketingOptInAnswerNoIdPatient: string;
    hasBeenPrescribedQuestionIdPatientAlprolix: string;
    hasBeenPrescribedAnswerYesIdPatientAlprolix: string;
    hasBeenPrescribedAnswerNoIdPatientAlprolix: string;
    iConsentQuestionIdPatient: string;
    iConsentAnswerYesIdPatient: string;
    iConsentQuestionIdHcp: string;
    iConsentAnswerYesIdHcp: string;
    hasBeenPrescribedQuestionIdPatientCablivi: string;
    hasBeenPrescribedAnswerYesIdPatientCablivi: string;
    hasBeenPrescribedAnswerNoIdPatientCablivi: string;
    hasBeenPrescribedQuestionIdPatientAltuviiio: string;
    hasBeenPrescribedAnswerYesIdPatientAltuviiio: string;
    hasBeenPrescribedAnswerNoIdPatientAltuviiio: string;
    hasBeenPrescribedQuestionIdHcpAlprolix: string;
    hasBeenPrescribedAnswerYesIdHcpAlprolix: string;
    hasBeenPrescribedAnswerNoIdHcpAlprolix: string;
    hasBeenPrescribedQuestionIdHcpCablivi: string;
    hasBeenPrescribedAnswerYesIdHcpCablivi: string;
    hasBeenPrescribedAnswerNoIdHcpCablivi: string;
    hasBeenPrescribedQuestionIdHcpAltuviiio: string;
    hasBeenPrescribedAnswerYesIdHcpAltuviiio: string;
    hasBeenPrescribedAnswerNoIdHcpAltuviiio: string;
    isUSResidentQuestionIdHcp: string;
    isUSResidentAnswerYesIdHcp: string;
    isUSResidentAnswerNoIdHcp: string;
    isPrescriberInUsIdPatient: string;
    isPrescriberInUsIdAnswerYesIdPatient: string;
    isPrescriberInUsIdAnswerNoIdPatient: string;
    isPrescriberInUsIdHcp: string;
    isPrescriberInUsIdAnswerYesIdHcp: string;
    isPrescriberInUsIdAnswerNoIdHcp: string;
    eligibility_1_question_alprolix_patient: string;
    eligibility_1_question_cablivi_patient: string;
    eligibility_1_question_altuviiio_patient: string;
    eligibility_1_question_alprolix_hcp: string;
    eligibility_1_question_cablivi_hcp: string;
    eligibility_1_question_altuviiio_hcp: string;
    eligibility_2_question_patient: string;
    eligibility_2_question_hcp: string;
    eligibility_3_question_patient: string;
    eligibility_3_question_alprolix_hcp: string;
    eligibility_3_question_cablivi_hcp: string;
    eligibility_3_question_altuviiio_hcp: string;
    eligibility_4_question_patient: string;
    eligibility_4_question_hcp: string;
    eligibility_5_question_patient: string;
    eligibility_5_question_hcp: string;
    eligibility_6_question_patient: string;
    eligibility_6_question_hcp: string;
    eligibility_7_question: string;
    eligibility_7_question_hcp: string;
    patientInfo_1_hcp: string;
    patientInfo_1_patient: string;
    patientInfo_2_patient: string;
    patientInfo_2_hcp: string;
    patientInfo_31_patient: string;
    patientInfo_31_hcp: string;
    patientInfo_32_patient: string;
    patientInfo_32_hcp: string;
    medicationPathName: string;
    eloctatePatient: string;
    eloctateHCP: string;
    alprolixPatient: string;
    alprolixHCP: string;
    altuviiioPatient: string;
    altuviiioHCP: string;
    triangleUp: string;
    triangleDown: string;
    lockEnabled: string;
    lockPassword: string;
    hideDocumentUpload: string;
    howDoYouQuestionId: string;
    howDoYouTreatProphy: string;
    howDoYouTreatOnDemand: string;
    howDoYouTreatPreferNotToAnswer: string;

    pleaseSelectOneQuestionId: string;
    patientInterestedAlprolix: string;
    hcpInterestedAlprolix: string;
    patientChildAlprolix: string;
    hcpChildAlprolix: string;

    patientInterestedEloctate: string;
    hcpInterestedEloctate: string;
    patientChildEloctate: string;
    hcpChildEloctate: string;

    patientInterestedAltuviiio: string;
    hcpInterestedAltuviiio: string;
    patientChildAltuviiio: string;
    hcpChildAltuviiio: string;
    showSplashPage: string;

    preferredContactMethodQuestionId: string;
    preferredContactMethodEmailAnswerId: string;
    preferredContactMethodPhoneAnswerId: string;
    preferredContactMethodEmailPhoneAnswerId: string;

    pleaseSelectOne: string;
    iInterestedCABLIVI: string;
    iCurrentlyCABLIVI: string;
    hcpIInterestedCABLIVI: string;
    hcpICurrentlyCABLIVI: string;

    medicationId: string;
    medicationCabliviPatientAnswerId: string;
    medicationCabliviHcpAnswerId: string;

    iSecondConsentQuestionIdPatient: string;
    iSecondConsentQuestionYesIdPatient: string;
    iSecondConsentQuestionNoIdPatient: string;

    magentaCardArt: string;

    COOKIEENVONE:string;
    DATADOMAIN:string;

}
